import { format, parseISO } from "date-fns";
import React from "react";
import { DATE_WITH_TIME_FORMAT } from "DateFormats";

type DateAtTimeProps = { time: string };

export const DateAtTime = ({ time }: DateAtTimeProps) => {
  return <span>{format(parseISO(time), DATE_WITH_TIME_FORMAT)}</span>;
};
